<template>
    <div>
        <div class="w-full block lg:flex gap-3 lg:justify-between">
            <Popover v-slot="{ open }" class="relative mr-3" v-if="showFilter">
                <PopoverButton
                    class="inline-flex items-center px-3 py-2 text-base bg-orange-700 rounded-md group hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
                    <span class="text-sm">Filter</span>
                    <ChevronDownIcon :class="open ? '' : 'text-opacity-70'"
                                     class="w-5 h-5 ml-2 text-orange-300 transition duration-150 ease-in-out group-hover:text-opacity-80"
                                     aria-hidden="true"/>
                </PopoverButton>

                <transition
                    enter-active-class="transition duration-200 ease-out"
                    enter-from-class="translate-y-1 opacity-0"
                    enter-to-class="translate-y-0 opacity-100"
                    leave-active-class="transition duration-150 ease-in"
                    leave-from-class="translate-y-0 opacity-100"
                    leave-to-class="translate-y-1 opacity-0"
                >
                    <PopoverPanel
                        class="absolute bg-white z-10 w-screen max-w-xs px-4 mt-3 transform -translate-x-1/2 left-1/2 sm:px-0 lg:max-w-xs"
                    >
                        <div
                            class="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5"
                        >
                            <div class="relative gap-8 bg-white p-7">
                                <slot/>
                            </div>
                        </div>
                    </PopoverPanel>
                </transition>
            </Popover>
            <input class="shadow-sm focus:ring-indigo-500 focus:border-light-pitch-purple block w-full sm:text-sm border-gray-300 rounded-md" autocomplete="off" type="text" name="search"
                   placeholder="Search by Invoice, Project reference or Client…" :value="value" @input="$emit('update:value', $event.target.value)"/>

            <button class="w-1/4 text-sm text-gray-500 hover:text-gray-700" type="button"
                    @click="$emit('reset')">Reset Search
            </button>
        </div>
    </div>
</template>

<script>
import {Popover, PopoverButton, PopoverPanel} from '@headlessui/vue'
import {ChevronDownIcon} from '@heroicons/vue/solid'

export default {
    components: {
        Popover,
        PopoverPanel,
        PopoverButton,
        ChevronDownIcon
    },
    props: {
        value: String,
        maxWidth: {
            type: Number,
            default: 300,
        },
        showFilter: {
            type: Boolean,
            default: true
        }
    },
}
</script>
